import { rand, randWord, randNumber } from '@ngneat/falso';
import { optional } from '@library/common/functions';

import { SourceSystem } from './admin-enum';
import { SourceSystems } from './admin-enum.mock';

import { AdminSourceSystem, SourceSystemPkey } from './admin-source-system';

class SourceSystemSeed {
   name: string;
   services: SourceSystem['services'];
   keys: SourceSystemPkey = {};

   constructor( source: SourceSystem ) {
      this.name = source?.name;
      this.services = source?.services;
      source?.keys.map( k => optional() ? this.keys[k.key] = randWord() : null );
   }
}

export class MockAdminSourceSystem extends AdminSourceSystem {
   constructor( portal: string = 'customer', seed?: SourceSystemSeed ) {

      const ss = seed ? SourceSystems[portal].filter( s => s.name === seed.name )[0] : rand( SourceSystems[portal] );
      seed = new SourceSystemSeed( ss );

      const service = rand( ss?.services ?? [] );

      const pkey: SourceSystemPkey = {};
      ss?.keys.filter( key => service?.required_keys?.includes( key.key ))
         .map( key => pkey[key.key] = seed?.keys[key.key] );

      super({
         id: service?.id,
         sourceSystem: ss?.name,
         sourceSystemPkey: pkey,
      });
   }
}

export function MockAdminSourceSystemArray( portal: string = 'customer' ) {
   const seed = new SourceSystemSeed( rand( SourceSystems[portal] ));

   return Array.from({
      length: randNumber({ min: 3, max: 10 })
   }, _ => new MockAdminSourceSystem( portal, ( optional( 70 ) ? seed : null )))
      .filter(( v, i, a ) => a.map( j => j.id ).indexOf( v.id ) === i );
}
